import { useRef } from "react";
import { useIntl } from "react-intl";
import Button from "@/component/Button";
import FileInput from "@/component/input/FileInput";


interface ImageUploadBtnProps {
    disabled?: boolean;
    onUpload: (file: File, url: string) => void | Promise<void>;
}

const ImageUploadBtn = (props: ImageUploadBtnProps) => {
    const { disabled, onUpload } = props;

    const intl = useIntl();

    const fileInputRef = useRef<HTMLInputElement>(null);

    const onChangeFile = async (files: File[]) => {
        const file = files[0];
        if (!file) {
            return;
        }
        const url = URL.createObjectURL(file);
        await onUpload(file, url);
    };

    return (<>
        <Button size="sm"
                variant="primary"
                disabled={disabled}
                onClick={() => fileInputRef.current?.click()}
        >
            {intl.formatMessage({ id: "i00013" })}
        </Button>
        <FileInput ref={fileInputRef}
                   accept=".jpg,.jpeg,.png,.gif"
                   onUpload={onChangeFile}
        />
    </>);
};

export default ImageUploadBtn;